import {createContext, useContext, useEffect, useState, type ReactNode} from 'react'

type GodMode = {
  /** An admin is inside someone else's business (god mode applies). */
  active: boolean
  /** Editing deliberately enabled for this visit. */
  armed: boolean
  setArmed: (armed: boolean) => void
}

const GodModeContext = createContext<GodMode>({active: false, armed: false, setArmed: () => {}})

/** Cinturón de la UI: se desarma al entrar a cada empresa; la API conserva los permisos de god mode. */
export function GodModeProvider({
  active,
  businessId,
  children,
}: {
  active: boolean
  businessId: string | undefined
  children: ReactNode
}) {
  const [armed, setArmed] = useState(false)
  useEffect(() => setArmed(false), [businessId])
  return <GodModeContext.Provider value={{active, armed, setArmed}}>{children}</GodModeContext.Provider>
}

export function useGodMode(): GodMode {
  return useContext(GodModeContext)
}

export function useGodModeReadOnly(): boolean {
  const {active, armed} = useContext(GodModeContext)
  return active && !armed
}
